import { useState } from 'react';
import { ArrowLeft, FileText, Server } from 'lucide-react';
import { KnowledgeSet } from '@/types/knowledge';
import { LocalFiles } from './LocalFiles';
import { ContentProvidersTable } from './ContentProvidersTable';
import { cn } from '@/lib/utils';

interface KnowledgeSetDetailProps {
    knowledgeSet: KnowledgeSet;
    onBack: () => void;
}

export const KnowledgeSetDetail = ({ knowledgeSet, onBack }: KnowledgeSetDetailProps) => {
    const [activeTab, setActiveTab] = useState<'files' | 'providers'>('files');

    return (
        <div className="w-full">
            {/* Header */}
            <div className="flex items-center mb-6">
                <button
                    onClick={onBack}
                    className="mr-4 focus:outline-none transition-colors text-primary hover:text-secondary"
                >
                    <ArrowLeft size={24} />
                </button>
                <div>
                    <h1 className="text-3xl font-bold text-foreground">
                        {knowledgeSet.name}
                    </h1>
                    {knowledgeSet.description && (
                        <p className="text-lg mt-1 text-muted-foreground">
                            {knowledgeSet.description}
                        </p>
                    )}
                </div>
            </div>

            {/* Tabs */}
            <div className="flex border-b mb-6 border-border">
                <button
                    onClick={() => setActiveTab('files')}
                    className={cn(
                        "px-6 py-3 font-medium transition-colors",
                        activeTab === 'files'
                            ? "text-primary border-b-2 border-primary"
                            : "text-muted-foreground hover:text-foreground"
                    )}
                >
                    <div className="flex items-center">
                        <FileText size={18} className="mr-2" />
                        Local Files
                    </div>
                </button>
                <button
                    onClick={() => setActiveTab('providers')}
                    className={cn(
                        "px-6 py-3 font-medium transition-colors",
                        activeTab === 'providers'
                            ? "text-primary border-b-2 border-primary"
                            : "text-muted-foreground hover:text-foreground"
                    )}
                >
                    <div className="flex items-center">
                        <Server size={18} className="mr-2" />
                        External Content Providers
                    </div>
                </button>
            </div>

            {/* Tab Content */}
            <div>
                {activeTab === 'files' && <LocalFiles />}
                {activeTab === 'providers' && (
                    <ContentProvidersTable />
                )}
            </div>
        </div>
    );
};
